import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { useSharedData } from './SharedDataContext';

interface PageTitleContextType {
  pageTitle: string;
  setPageTitle: (title: string) => void;
}

const PageTitleContext = createContext<PageTitleContextType | undefined>(undefined);

export const usePageTitle = () => {
  const context = useContext(PageTitleContext);
  if (context === undefined) {
    throw new Error('usePageTitle must be used within a PageTitleProvider');
  }
  return context;
};

interface PageTitleProviderProps {
  children: ReactNode;
}

export const PageTitleProvider: React.FC<PageTitleProviderProps> = ({ children }) => {
  const [pageTitle, setPageTitle] = useState('');
  const { shareData } = useSharedData();

  useEffect(() => {
    if (shareData?.pageTitle) {
      setPageTitle(shareData.pageTitle);
    }
  }, [shareData]);

  const value = {
    pageTitle,
    setPageTitle,
  };

  return (
    <PageTitleContext.Provider value={value}>
      {children}
    </PageTitleContext.Provider>
  );
};
